export class CartNotInitializedError extends Error {
    public constructor() {
        super('Cart is not initialized');
    }
}
